import React, { useEffect, useState, useRef, memo } from 'react';
import { TestimonialCard } from './TestimonialCard';
import { CTAButton } from './CTAButton';
import { StickyCTA } from './StickyCTA';
import { EyeIcon, CheckCircle, AlertCircle } from 'lucide-react';
export const Advertorial = () => {
  const [isScrolledPastFirstTwoSections, setIsScrolledPastFirstTwoSections] = useState(false);
  const [isAtTopSection, setIsAtTopSection] = useState(true);
  const [userCity, setUserCity] = useState('Your City');
  const firstTwoSectionsRef = useRef(null);
  // Fetch user location data
  useEffect(() => {
    const fetchUserLocation = async () => {
      try {
        const response = await fetch('https://ipinfo.io/json');
        if (response.ok) {
          const data = await response.json();
          if (data.city && data.city.trim() !== '') {
            setUserCity(data.city);
            console.log(`User location detected: ${data.city}`);
          }
        }
      } catch (error) {
        console.error('Error fetching location data:', error);
      }
    };
    fetchUserLocation();
  }, []);
  useEffect(() => {
    setIsScrolledPastFirstTwoSections(false);
    setIsAtTopSection(true);
    const scrollOptions = {
      threshold: 0.1,
      rootMargin: '0px 0px -90% 0px'
    };
    const topSectionOptions = {
      threshold: 0.3,
      rootMargin: '-100px 0px 0px 0px'
    };
    const scrollObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (!entry.isIntersecting) {
          setIsScrolledPastFirstTwoSections(true);
        } else {
          setIsScrolledPastFirstTwoSections(false);
        }
      });
    }, scrollOptions);
    const topSectionObserver = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setIsAtTopSection(true);
        } else {
          setIsAtTopSection(false);
        }
      });
    }, topSectionOptions);
    setTimeout(() => {
      if (firstTwoSectionsRef.current) {
        scrollObserver.observe(firstTwoSectionsRef.current);
        topSectionObserver.observe(firstTwoSectionsRef.current);
      }
    }, 100);
    return () => {
      if (firstTwoSectionsRef.current) {
        scrollObserver.unobserve(firstTwoSectionsRef.current);
        topSectionObserver.unobserve(firstTwoSectionsRef.current);
      }
    };
  }, []);
  return <div className="w-full bg-white" data-id="element-7">
      {/* Top Header Bar */}
      <div className="w-full bg-gray-900 text-white" data-id="element-8">
        <div className="container mx-auto px-4 py-2 flex flex-col sm:flex-row justify-between items-center gap-2" data-id="element-9">
          <div className="flex items-center" data-id="element-10">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg" className="mr-2 flex-shrink-0" data-id="element-11">
              <path d="M12 2L15.09 8.26L22 9.27L17 14.14L18.18 21.02L12 17.77L5.82 21.02L7 14.14L2 9.27L8.91 8.26L12 2Z" fill="white" data-id="element-12" />
            </svg>
            <span className="font-semibold tracking-wider text-sm sm:text-base" data-id="element-13">
              HEALTH & WELLNESS
            </span>
          </div>
          <div className="flex items-center" data-id="element-14">
            <div className="w-5 h-5 mr-2 rounded-full overflow-hidden flex-shrink-0" data-id="element-15">
              <svg viewBox="0 0 512 512" className="w-full h-full" data-id="element-16">
                <path fill="#f0f0f0" d="M0 85.331h512v341.337H0z" data-id="element-17" />
                <path fill="#d80027" d="M0 85.331h512v42.663H0zm0 85.337h512v42.663H0zm0 85.337h512v42.663H0zm0 85.337h512v42.663H0z" data-id="element-18" />
                <path fill="#2e52b2" d="M0 85.331h256v183.797H0z" data-id="element-19" />
                <path fill="#f0f0f0" d="M99.822 160.624L95.699 173.308H82.363L93.113 181.143L89.021 193.826L99.822 186.034L110.624 193.826L106.532 181.143L117.306 173.308H103.97z" data-id="element-20" />
                <path fill="#f0f0f0" d="M103.622 219.081l-3.284 10.134h-10.638l8.609 6.333-3.284 10.134 8.598-6.348 8.598 6.348-3.284-10.134 8.609-6.333h-10.638zM167.737 160.624l-4.123 12.684h-13.336l10.75 7.835-4.092 12.683 10.801-7.792 10.802 7.792-4.092-12.683 10.774-7.835h-13.336zM167.737 219.081l-3.284 10.134h-10.638l8.609 6.333-3.284 10.134 8.598-6.348 8.598 6.348-3.284-10.134 8.609-6.333h-10.638zM31.908 160.624l-4.123 12.684H14.449l10.75 7.835-4.092 12.683 10.801-7.792 10.802 7.792-4.092-12.683 10.774-7.835H36.031zM31.908 219.081l-3.284 10.134H17.986l8.609 6.333-3.284 10.134 8.598-6.348 8.598 6.348-3.284-10.134 8.609-6.333H35.192z" data-id="element-21" />
              </svg>
            </div>
            <span className="text-sm" data-id="element-22">Trending in the US</span>
          </div>
        </div>
      </div>
      {/* Header */}
      <header className="w-full border-b border-gray-200" data-id="element-23">
        <div className="container mx-auto px-4 py-3" data-id="element-24">
          <p className="text-xs font-semibold text-gray-500 tracking-wider" data-id="element-25">
            HEALTH & WELLNESS | Advertorial
          </p>
        </div>
      </header>
      {/* Notification Banner */}
      <div className="w-full bg-amber-50 border border-amber-200" data-id="element-26">
        <div className="container mx-auto px-4 py-3" data-id="element-27">
          <div className="flex items-start sm:items-center justify-center text-center gap-2" data-id="element-28">
            <AlertCircle className="text-red-500 flex-shrink-0 mt-0.5 sm:mt-0" size={20} data-id="element-29" />
            <p className="font-bold text-xs sm:text-sm md:text-base" data-id="element-30">
              UPDATE: RejuvaNeck™ Is Selling Out FAST! Grab Yours NOW to get
              40% OFF + Fast FREE Shipping Across the US
            </p>
          </div>
        </div>
      </div>
      {/* Main Content */}
      <div className="container mx-auto px-4 pb-24 lg:pb-6" data-id="element-31">
        <div className="flex flex-col lg:flex-row lg:justify-center lg:gap-8" data-id="element-32">
          {/* Main Content */}
          <main className="w-full max-w-3xl mx-auto" data-id="element-33">
            <div className="py-4 sm:py-6 px-0 sm:px-4" data-id="element-34">
              {/* Headline */}
              <h1 className="text-2xl md:text-3xl lg:text-4xl font-bold text-gray-800 mb-4" data-id="element-35">
                {userCity} Doctors Reveal: This "Neck Hump" Can Finally Be
                Reversed At Home Without Surgery
              </h1>
              {/* Subheadline */}
              <p className="text-lg md:text-xl text-gray-600 mb-6" data-id="element-36">
                Thousands of women over 40 are erasing their neck hump in just
                15 minutes a day with this breakthrough device
              </p>
              {/* Author and Date */}
              <div className="flex flex-col sm:flex-row sm:items-center justify-between border-b border-gray-200 pb-4 mb-6 gap-2" data-id="element-37">
                <div className="flex items-center" data-id="element-38">
                  <p className="text-xs sm:text-sm text-gray-700" data-id="element-39">
                    By Sarah Mitchell, Health & Wellness | Updated: November 11,
                    2025
                  </p>
                </div>
                <div className="flex items-center text-xs sm:text-sm text-gray-500" data-id="element-40">
                  <EyeIcon size={16} className="mr-1 flex-shrink-0" data-id="element-41" />
                  <span data-id="element-42">189,432</span>
                </div>
              </div>
              {/* Featured Image */}
              <div className="mb-8 rounded-lg overflow-hidden" data-id="element-43">
                <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/cZQpEARfaoPacEkAZr5Dxe/ChatGPT_Image_11_%CE%9D%CE%BF%CE%B5_2025%2C_09_06_55_%CE%BC.%CE%BC..png" alt="Woman looking at her neck posture in mirror, concerned about neck hump" className="w-full h-auto" data-id="element-44" />
              </div>
              {/* Personal Story Section */}
              <div className="mb-10" data-id="element-45">
                <p className="mb-4" data-id="element-46">
                  If you've noticed a small bump forming at the base of your
                  neck...
                </p>
                <p className="mb-4" data-id="element-47">
                  If you catch yourself in photos looking more "hunched" than
                  you remember...
                </p>
                <p className="mb-4" data-id="element-48">
                  If you feel stiff, tired, and older than your years every time
                  you look in the mirror...
                </p>
                <p className="mb-4" data-id="element-49">
                  You're not alone. And it's not your fault.
                </p>
                <p className="mb-4" data-id="element-50">
                  More than 8 million American women between 35 and 60 are
                  dealing with what doctors call "postural hyperkyphosis" — but
                  what most of us know as the dreaded "neck hump" or "tech
                  neck."
                </p>
                <p className="mb-4" data-id="element-51">
                  For years, women like you have been told the same frustrating
                  advice: "Just sit up straight." "Fix your posture." "Do some
                  stretches."
                </p>
                <p className="mb-4 font-semibold" data-id="element-52">
                  But here's what nobody tells you...
                </p>
                <div className="bg-blue-50 p-4 rounded-md mb-4 border-l-4 border-blue-500" data-id="element-53">
                  <p className="font-semibold mb-2" data-id="element-54">💡 CRITICAL INSIGHT:</p>
                  <p data-id="element-55">
                    That advice was based on 1917 science that's been completely
                    debunked.
                  </p>
                </div>
                <p className="mb-4" data-id="element-56">
                  The real problem isn't "bad posture" or "slouching." It's
                  something far deeper — and until now, almost impossible to fix
                  without years of expensive physical therapy or invasive
                  procedures.
                </p>
              </div>
              {/* The Hidden Condition Section */}
              <div className="mb-10" ref={firstTwoSectionsRef} data-id="element-57">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-58">
                  The Shocking Truth: Why Your Neck Hump Keeps Getting Worse (No
                  Matter What You Try)
                </h2>
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-59">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/jFdcKzRDDHywZ7PgrzA1wD/ChatGPT_Image_11_%CE%9D%CE%BF%CE%B5_2025%2C_09_06_54_%CE%BC.%CE%BC..png" alt="Woman frustrated trying different posture correctors and stretches" className="w-full h-auto" data-id="element-60" />
                </div>
                <p className="mb-4" data-id="element-61">Let me ask you something...</p>
                <p className="mb-4" data-id="element-62">
                  Have you tried posture correctors that felt uncomfortable and
                  didn't actually change anything?
                </p>
                <p className="mb-4" data-id="element-63">
                  Have you done stretches and exercises that seem to help
                  temporarily, but the hump always comes back?
                </p>
                <p className="mb-4" data-id="element-64">
                  Have you bought ergonomic pillows or special chairs, hoping
                  they'd fix the problem while you sleep?
                </p>
                <p className="mb-4" data-id="element-65">
                  If you're nodding your head right now, you need to know this
                  isn't your fault.
                </p>
                <p className="mb-4" data-id="element-66">
                  According to recent clinical research, the neck hump isn't
                  caused by simply having "bad posture."
                </p>
                <p className="mb-4 font-semibold" data-id="element-67">
                  The real culprit is something called "The Postural Loop
                  Breakdown™"
                </p>
                <div className="bg-red-50 p-4 rounded-md mb-6" data-id="element-68">
                  <p className="font-semibold mb-2" data-id="element-69">
                    ⚠️ WHAT IS THE POSTURAL LOOP BREAKDOWN?
                  </p>
                  <p className="mb-3" data-id="element-70">
                    Years of screen time, chronic stress, and natural hormonal
                    changes (especially after 40) create a neuromuscular
                    disconnect in your neck.
                  </p>
                  <p className="mb-2" data-id="element-71">Here's what happens:</p>
                  <ul className="list-none space-y-2 mb-3" data-id="element-72">
                    <li data-id="element-73">
                      ✗ Your deep cervical stabilizer muscles (the ones that
                      hold your head upright naturally) become weak and "turn
                      off"
                    </li>
                    <li data-id="element-74">
                      ✗ Meanwhile, your upper trapezius and suboccipital muscles
                      become chronically tight and overworked, trying to
                      compensate
                    </li>
                    <li data-id="element-75">
                      ✗ Your body enters a self-reinforcing cycle: tension →
                      muscle imbalance → forward head posture → tissue buildup →
                      more tension
                    </li>
                  </ul>
                  <p className="font-semibold" data-id="element-76">
                    This is why the hump keeps coming back. Your brain-body
                    connection that controls upright posture is literally
                    broken.
                  </p>
                </div>
                <p className="mb-4" data-id="element-77">Think about it...</p>
                <p className="mb-4" data-id="element-78">
                  Posture braces act as a crutch — they don't strengthen your
                  deep muscles. They actually make them weaker.
                </p>
                <p className="mb-4" data-id="element-79">
                  Generic stretches might loosen tight muscles temporarily, but
                  they don't reactivate the deep stabilizers that have "turned
                  off."
                </p>
                <p className="mb-4" data-id="element-80">
                  Chiropractic adjustments provide relief for a few days, but
                  the structural imbalance remains — so you're back to square
                  one by next week.
                </p>
                <p className="mb-4 font-semibold" data-id="element-81">
                  This is why thousands of women have told me: "Nothing I've
                  tried actually works."
                </p>
              </div>
              {/* The Hidden Cost Section */}
              <div className="mb-10" data-id="element-82">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-83">
                  The Hidden Cost of Living With a Neck Hump
                </h2>
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-84">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/aZeCLoWB4ahH3ZRGPfxMe2/ChatGPT_Image_11_%CE%9D%CE%BF%CE%B5_2025%2C_09_06_52_%CE%BC.%CE%BC..png" alt="Woman looking self-conscious about her posture" className="w-full h-auto" data-id="element-85" />
                </div>
                <p className="mb-4" data-id="element-86">
                  I've spoken to hundreds of women dealing with this condition,
                  and they all say the same things:
                </p>
                <div className="bg-gray-50 p-4 rounded-md mb-4 space-y-2" data-id="element-87">
                  <p className="italic" data-id="element-88">
                    "I hate how it looks when I wear my hair up."
                  </p>
                  <p className="italic" data-id="element-89">
                    "I feel like I look so much older in photos."
                  </p>
                  <p className="italic" data-id="element-90">
                    "I can't wear fitted tops anymore without feeling
                    self-conscious."
                  </p>
                  <p className="italic" data-id="element-91">
                    "My husband took a photo of me at my daughter's wedding, and
                    all I could see was that hump."
                  </p>
                </div>
                <p className="mb-4" data-id="element-92">
                  But beyond the embarrassment, there's something even more
                  concerning...
                </p>
                <p className="mb-4" data-id="element-93">
                  Medical studies show that postural hyperkyphosis isn't just
                  cosmetic. It's associated with:
                </p>
                <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-94">
                  <li data-id="element-95">
                    Chronic neck and shoulder pain that gets worse over time
                  </li>
                  <li data-id="element-96">Headaches and migraines</li>
                  <li data-id="element-97">Reduced lung capacity and breathing problems</li>
                  <li data-id="element-98">
                    Higher risk of falls and vertebral fractures as you age
                  </li>
                  <li data-id="element-99">Earlier mortality in severe cases</li>
                </ul>
                <p className="mb-4" data-id="element-100">
                  And here's what really breaks my heart...
                </p>
                <p className="mb-4" data-id="element-101">
                  Many women tell me they've simply accepted it as part of
                  aging. They believe there's nothing they can do about it
                  except hide it with scarves, collars, and strategic clothing
                  choices.
                </p>
                <p className="mb-4" data-id="element-102">
                  They avoid social situations. They refuse to have their photo
                  taken. They feel invisible.
                </p>
                <p className="mb-4 font-semibold" data-id="element-103">
                  But what if I told you there's finally a solution?
                </p>
              </div>
              {/* The Breakthrough Section */}
              <div className="mb-10" data-id="element-104">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-105">
                  The European Secret That's Been Hidden for 100 Years
                </h2>
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-106">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/3WbsMD4cBj7SXJ2vkgcXWi/%CE%91%CE%BD%CF%89%CE%BD%CF%85%CE%BC%CE%BF_%CF%83%CF%87%CE%B5%CE%B4%CE%B9%CE%BF_%2845%29.png" alt="RejuvaNeck device product shot" className="w-full h-auto" data-id="element-107" />
                </div>
                <p className="mb-4" data-id="element-108">
                  In 1921, a German physiotherapist named Katharina Schroth made
                  a breakthrough discovery.
                </p>
                <p className="mb-4" data-id="element-109">
                  She herself suffered from severe spinal curvature, and she
                  refused to accept the "standard treatment" of the time — which
                  was wearing painful steel braces that weakened the muscles
                  even more.
                </p>
                <p className="mb-4" data-id="element-110">
                  Instead, she developed something revolutionary: a method that
                  reactivated the deep stabilizer muscles through targeted
                  stimulation and breathing techniques.
                </p>
                <p className="mb-4" data-id="element-111">
                  Her method worked so well that it's still the gold standard
                  for postural correction in Europe today.
                </p>
                <p className="mb-4" data-id="element-112">But here's the problem...</p>
                <p className="mb-4" data-id="element-113">
                  The Schroth Method requires years of intensive physical
                  therapy sessions, highly trained practitioners, and costs tens
                  of thousands of dollars.
                </p>
                <p className="mb-4 font-semibold" data-id="element-114">Until now.</p>
              </div>
              {/* RejuvaNeck Introduction */}
              <div className="mb-10" data-id="element-115">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-116">
                  Introducing RejuvaNeck™: The First At-Home Device That
                  Retrains Your Posture From The Inside Out
                </h2>
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-117">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/wp4sQYB4iwuyYTZMveXAFm/ChatGPT_Image_11_%CE%9D%CE%BF%CE%B5_2025%2C_09_00_44_%CE%BC.%CE%BC..png" alt="RejuvaNeck device being used comfortably at home" className="w-full h-auto" data-id="element-118" />
                </div>
                <p className="mb-4" data-id="element-119">
                  RejuvaNeck™ is the first portable device that brings the
                  breakthrough principles of deep muscle reactivation therapy
                  into your home — in just 15 minutes a day.
                </p>
                <p className="mb-4" data-id="element-120">
                  Unlike every other solution on the market, RejuvaNeck™
                  doesn't just mask the problem or provide temporary relief.
                </p>
                <p className="mb-4 font-semibold" data-id="element-121">
                  It actually fixes the root cause.
                </p>
                <p className="mb-4" data-id="element-122">Here's how it works:</p>
                <div className="bg-blue-50 p-6 rounded-lg mb-6" data-id="element-123">
                  <h3 className="font-bold text-lg mb-3" data-id="element-124">
                    DEEP MUSCLE REACTIVATION THERAPY™
                  </h3>
                  <p className="mb-3" data-id="element-125">
                    RejuvaNeck™ uses a proprietary combination of EMS
                    Micro-Pulse Technology and soothing heat therapy to:
                  </p>
                  <div className="space-y-2" data-id="element-126">
                    <div className="flex items-start" data-id="element-127">
                      <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={20} data-id="element-128" />
                      <p data-id="element-129">
                        Reawaken your deep cervical flexor muscles — the
                        stabilizers that have "turned off" over the years
                      </p>
                    </div>
                    <div className="flex items-start" data-id="element-130">
                      <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={20} data-id="element-131" />
                      <p data-id="element-132">
                        Release chronic tension in the overworked trapezius and
                        suboccipital muscles
                      </p>
                    </div>
                    <div className="flex items-start" data-id="element-133">
                      <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={20} data-id="element-134" />
                      <p data-id="element-135">
                        Restore proper muscle balance so your neck naturally
                        returns to its correct alignment
                      </p>
                    </div>
                    <div className="flex items-start" data-id="element-136">
                      <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={20} data-id="element-137" />
                      <p data-id="element-138">
                        Encourage lymphatic drainage to reduce the visible
                        tissue buildup at the base of your neck
                      </p>
                    </div>
                    <div className="flex items-start" data-id="element-139">
                      <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={20} data-id="element-140" />
                      <p data-id="element-141">
                        Retrain your body's internal posture memory — so the
                        results last even after you stop using it
                      </p>
                    </div>
                  </div>
                </div>
                <p className="mb-4" data-id="element-142">
                  Think of it like physical therapy, but automated and targeted
                  specifically for your cervical spine.
                </p>
                <div className="bg-green-50 p-4 rounded-md mb-4 border-l-4 border-green-500" data-id="element-143">
                  <p className="font-semibold mb-2" data-id="element-144">💡 THE KEY DIFFERENCE:</p>
                  <p className="mb-1" data-id="element-145">
                    Posture correctors = External support that weakens muscles
                  </p>
                  <p className="mb-1" data-id="element-146">
                    Generic massagers = Temporary pain relief, no structural
                    change
                  </p>
                  <p className="font-semibold" data-id="element-147">
                    RejuvaNeck™ = Retrains the deep muscles that create lasting
                    structural correction
                  </p>
                </div>
                <p className="mb-4" data-id="element-148">
                  In clinical studies, participants using deep muscle
                  reactivation therapy saw:
                </p>
                <ul className="list-disc pl-6 mb-4 space-y-2" data-id="element-149">
                  <li data-id="element-150">
                    Significant reduction in kyphosis angle within 2-4 weeks
                  </li>
                  <li data-id="element-151">43% decrease in neck pain after just 14 days</li>
                  <li data-id="element-152">
                    Visible improvement in posture that continued even after
                    treatment ended
                  </li>
                  <li data-id="element-153">No relapse when combined with proper ergonomics</li>
                </ul>
                <p className="mb-4" data-id="element-154">And the best part?</p>
                <p className="mb-4" data-id="element-155">
                  You can do this at home, while watching TV, reading, or just
                  relaxing.
                </p>
                <p className="mb-4" data-id="element-156">
                  No expensive appointments. No grueling workout routines. No
                  discomfort.
                </p>
                <p className="mb-4 font-semibold" data-id="element-157">Just 15 minutes a day.</p>
              </div>
              {/* Testimonials Section */}
              <div className="mb-10" data-id="element-158">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-6" data-id="element-159">
                  "I Can Finally Wear My Hair Up Again!" — Real Women, Real
                  Results
                </h2>
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-160">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/xvpTP542fXVHo1xqVW3ZyL/ChatGPT_Image_11_%CE%9D%CE%BF%CE%B5_2025%2C_09_06_45_%CE%BC.%CE%BC..png" alt="Before and after comparison showing neck hump reduction" className="w-full h-auto" data-id="element-161" />
                </div>
                <div className="space-y-6 mb-6" data-id="element-162">
                  <TestimonialCard quote="I noticed the bump at the base of my neck getting worse over the past few years, especially after I started working from home. I tried everything — yoga, posture braces, even expensive massage appointments. Nothing worked. After just 2 weeks with RejuvaNeck, I could see a real difference in the mirror. After 6 weeks, the hump was almost completely gone. I'm 52 and I finally feel confident again." author="Linda M." age="52" location="Phoenix, AZ" imageUrl="https://images.unsplash.com/photo-1438761681033-6461ffad8d80?w=400&q=80" data-id="element-163" />
                  <TestimonialCard quote="My daughter took a photo of me at her graduation and I was horrified when I saw my profile. I looked so hunched and old. I ordered RejuvaNeck that same week. Three weeks in and not only is the hump visibly smaller, but my chronic neck pain is GONE. I can't believe I suffered for so long when this was the answer all along." author="Patricia R." age="48" location="Columbus, OH" imageUrl="https://images.unsplash.com/photo-1544005313-94ddf0286df2?w=400&q=80" data-id="element-164" />
                  <TestimonialCard quote="I'm a teacher and I'm on my feet all day, but I still developed this awful hump from constantly looking down at papers and my phone. The worst part was how self-conscious I felt in front of my students. RejuvaNeck has been a game-changer. I use it for 15 minutes every night and I've seen dramatic improvement in just a month. My posture is better, my confidence is back, and I don't avoid cameras anymore!" author="Jennifer K." age="41" location="Austin, TX" imageUrl="https://images.unsplash.com/photo-1487412720507-e7ab37603c6f?w=400&q=80" data-id="element-165" />
                  <TestimonialCard quote="After menopause, everything seemed to go downhill — including my posture. The hump appeared almost overnight and made me look 10 years older. I was skeptical about RejuvaNeck at first, but I'm so glad I tried it. Within 3 weeks, I noticed my shoulders were less rounded and the bump was shrinking. Now after 2 months, it's barely noticeable. This thing actually works!" author="Carol D." age="56" location="Denver, CO" imageUrl="https://images.unsplash.com/photo-1580489944761-15a19d654956?w=400&q=80" data-id="element-166" />
                </div>
              </div>
              {/* Why RejuvaNeck Works Section */}
              <div className="mb-10" data-id="element-167">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-168">
                  Why RejuvaNeck™ Works When Everything Else Fails
                </h2>
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-169">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/bvqfwob8dPWz11cGjepSyj/ChatGPT_Image_11_%CE%9D%CE%BF%CE%B5_2025%2C_09_06_43_%CE%BC.%CE%BC..png" alt="Comparison chart showing RejuvaNeck vs other solutions" className="w-full h-auto" data-id="element-170" />
                </div>
                <p className="mb-4" data-id="element-171">Let me show you the difference:</p>
                <div className="overflow-x-auto mb-6 -mx-4 sm:mx-0" data-id="element-172">
                  <div className="inline-block min-w-full align-middle px-4 sm:px-0" data-id="element-173">
                    <table className="w-full border-collapse border border-gray-300 text-sm" data-id="element-174">
                      <thead data-id="element-175">
                        <tr className="bg-gray-100" data-id="element-176">
                          <th className="border border-gray-300 p-2 sm:p-3 text-left text-xs sm:text-sm" data-id="element-177">
                            Solution
                          </th>
                          <th className="border border-gray-300 p-2 sm:p-3 text-center text-xs sm:text-sm" data-id="element-178">
                            Deep Muscles
                          </th>
                          <th className="border border-gray-300 p-2 sm:p-3 text-center text-xs sm:text-sm" data-id="element-179">
                            Lasting Results
                          </th>
                          <th className="border border-gray-300 p-2 sm:p-3 text-center text-xs sm:text-sm" data-id="element-180">
                            Comfortable
                          </th>
                          <th className="border border-gray-300 p-2 sm:p-3 text-center text-xs sm:text-sm" data-id="element-181">
                            Cost-Effective
                          </th>
                        </tr>
                      </thead>
                      <tbody data-id="element-182">
                        <tr className="bg-green-50" data-id="element-183">
                          <td className="border border-gray-300 p-2 sm:p-3 font-semibold text-xs sm:text-sm" data-id="element-184">
                            RejuvaNeck™
                          </td>
                          <td className="border border-gray-300 p-2 sm:p-3 text-center text-green-600 text-xs sm:text-sm" data-id="element-185">
                            ✓ YES
                          </td>
                          <td className="border border-gray-300 p-2 sm:p-3 text-center text-green-600 text-xs sm:text-sm" data-id="element-186">
                            ✓ YES
                          </td>
                          <td className="border border-gray-300 p-2 sm:p-3 text-center text-green-600 text-xs sm:text-sm" data-id="element-187">
                            ✓ YES
                          </td>
                          <td className="border border-gray-300 p-2 sm:p-3 text-center text-green-600 text-xs sm:text-sm" data-id="element-188">
                            ✓ YES
                          </td>
                        </tr>
                        <tr data-id="element-189">
                          <td className="border border-gray-300 p-2 sm:p-3 text-xs sm:text-sm" data-id="element-190">
                            Posture Braces
                          </td>
                          <td className="border border-gray-300 p-2 sm:p-3 text-center text-red-600 text-xs sm:text-sm" data-id="element-191">
                            ✗ NO
                          </td>
                          <td className="border border-gray-300 p-2 sm:p-3 text-center text-red-600 text-xs sm:text-sm" data-id="element-192">
                            ✗ NO
                          </td>
                          <td className="border border-gray-300 p-2 sm:p-3 text-center text-red-600 text-xs sm:text-sm" data-id="element-193">
                            ✗ NO
                          </td>
                          <td className="border border-gray-300 p-2 sm:p-3 text-center text-green-600 text-xs sm:text-sm" data-id="element-194">
                            ✓ YES
                          </td>
                        </tr>
                        <tr data-id="element-195">
                          <td className="border border-gray-300 p-2 sm:p-3 text-xs sm:text-sm" data-id="element-196">
                            Physical Therapy
                          </td>
                          <td className="border border-gray-300 p-2 sm:p-3 text-center text-green-600 text-xs sm:text-sm" data-id="element-197">
                            ✓ YES
                          </td>
                          <td className="border border-gray-300 p-2 sm:p-3 text-center text-green-600 text-xs sm:text-sm" data-id="element-198">
                            ✓ YES
                          </td>
                          <td className="border border-gray-300 p-2 sm:p-3 text-center text-green-600 text-xs sm:text-sm" data-id="element-199">
                            ✓ YES
                          </td>
                          <td className="border border-gray-300 p-2 sm:p-3 text-center text-red-600 text-xs sm:text-sm" data-id="element-200">
                            ✗ NO ($3,000+)
                          </td>
                        </tr>
                        <tr data-id="element-201">
                          <td className="border border-gray-300 p-2 sm:p-3 text-xs sm:text-sm" data-id="element-202">
                            Massage Devices
                          </td>
                          <td className="border border-gray-300 p-2 sm:p-3 text-center text-red-600 text-xs sm:text-sm" data-id="element-203">
                            ✗ NO
                          </td>
                          <td className="border border-gray-300 p-2 sm:p-3 text-center text-red-600 text-xs sm:text-sm" data-id="element-204">
                            ✗ NO
                          </td>
                          <td className="border border-gray-300 p-2 sm:p-3 text-center text-yellow-600 text-xs sm:text-sm" data-id="element-205">
                            ~ Mixed
                          </td>
                          <td className="border border-gray-300 p-2 sm:p-3 text-center text-green-600 text-xs sm:text-sm" data-id="element-206">
                            ✓ YES
                          </td>
                        </tr>
                        <tr data-id="element-207">
                          <td className="border border-gray-300 p-2 sm:p-3 text-xs sm:text-sm" data-id="element-208">
                            Chiropractic
                          </td>
                          <td className="border border-gray-300 p-2 sm:p-3 text-center text-yellow-600 text-xs sm:text-sm" data-id="element-209">
                            ~ Temporary
                          </td>
                          <td className="border border-gray-300 p-2 sm:p-3 text-center text-red-600 text-xs sm:text-sm" data-id="element-210">
                            ✗ NO
                          </td>
                          <td className="border border-gray-300 p-2 sm:p-3 text-center text-green-600 text-xs sm:text-sm" data-id="element-211">
                            ✓ YES
                          </td>
                          <td className="border border-gray-300 p-2 sm:p-3 text-center text-red-600 text-xs sm:text-sm" data-id="element-212">
                            ✗ NO ($150/session)
                          </td>
                        </tr>
                      </tbody>
                    </table>
                  </div>
                </div>
                <h3 className="font-bold text-lg mb-3" data-id="element-213">
                  WHAT MAKES REJUVANECK™ DIFFERENT?
                </h3>
                <div className="space-y-6 mb-6" data-id="element-214">
                  <div className="bg-blue-50 p-6 rounded-lg" data-id="element-215">
                    <h4 className="font-bold text-lg mb-2" data-id="element-216">
                      1. EMS MICRO-PULSE TECHNOLOGY
                    </h4>
                    <p data-id="element-217">
                      Unlike percussion massagers (like Theragun) that can be
                      loud, jarring, and actually cause you to tense up,
                      RejuvaNeck™ uses gentle electrical muscle stimulation
                      that mimics the signals your brain sends to healthy,
                      active muscles.
                    </p>
                    <p className="mt-2" data-id="element-218">
                      It's completely comfortable — you'll feel a gentle pulsing
                      sensation that actually helps you relax.
                    </p>
                  </div>
                  <div className="bg-blue-50 p-6 rounded-lg" data-id="element-219">
                    <h4 className="font-bold text-lg mb-2" data-id="element-220">
                      2. SOOTHING HEAT THERAPY
                    </h4>
                    <p className="mb-2" data-id="element-221">
                      The combination of heat and EMS is scientifically proven
                      to:
                    </p>
                    <ul className="list-disc pl-6 space-y-1" data-id="element-222">
                      <li data-id="element-223">Increase blood flow and oxygen to dormant muscles</li>
                      <li data-id="element-224">Release stubborn fascial adhesions</li>
                      <li data-id="element-225">Accelerate the healing and retraining process</li>
                      <li data-id="element-226">
                        Provide immediate pain relief while structural
                        correction happens
                      </li>
                    </ul>
                  </div>
                  <div className="bg-blue-50 p-6 rounded-lg" data-id="element-227">
                    <h4 className="font-bold text-lg mb-2" data-id="element-228">
                      3. ERGONOMICALLY DESIGNED FOR YOUR NECK
                    </h4>
                    <p data-id="element-229">
                      While other devices are "one-size-fits-all," RejuvaNeck™
                      is specifically engineered for the cervical spine and
                      upper trapezius region — exactly where the postural
                      breakdown occurs.
                    </p>
                  </div>
                  <div className="bg-blue-50 p-6 rounded-lg" data-id="element-230">
                    <h4 className="font-bold text-lg mb-2" data-id="element-231">
                      4. PORTABLE & HANDS-FREE
                    </h4>
                    <p className="mb-2" data-id="element-232">Use it while:</p>
                    <ul className="list-disc pl-6 space-y-1" data-id="element-233">
                      <li data-id="element-234">Watching your favorite shows</li>
                      <li data-id="element-235">Reading before bed</li>
                      <li data-id="element-236">Working at your desk</li>
                      <li data-id="element-237">Traveling (TSA-approved!)</li>
                    </ul>
                  </div>
                  <div className="bg-blue-50 p-6 rounded-lg" data-id="element-238">
                    <h4 className="font-bold text-lg mb-2" data-id="element-239">
                      5. NO ONGOING COSTS
                    </h4>
                    <p data-id="element-240">
                      Unlike other devices that require expensive refill pads or
                      subscriptions, RejuvaNeck™ is a one-time purchase with
                      unlimited use.
                    </p>
                  </div>
                </div>
              </div>
              {/* Timeline Section */}
              <div className="mb-10" data-id="element-241">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-242">
                  Here's What Happens When You Start Using RejuvaNeck™
                </h2>
                <div className="space-y-4 mb-6" data-id="element-243">
                  <div className="bg-gradient-to-r from-blue-50 to-blue-100 p-5 rounded-lg" data-id="element-244">
                    <h4 className="font-bold text-lg mb-2" data-id="element-245">
                      WEEK 1-2: Relief & Awareness
                    </h4>
                    <p data-id="element-246">
                      You'll notice immediate tension relief in your neck and
                      shoulders. Many users report their chronic "knots" melting
                      away. You'll also become more aware of your posture
                      throughout the day.
                    </p>
                  </div>
                  <div className="bg-gradient-to-r from-green-50 to-green-100 p-5 rounded-lg" data-id="element-247">
                    <h4 className="font-bold text-lg mb-2" data-id="element-248">
                      WEEK 3-4: Visible Changes
                    </h4>
                    <p data-id="element-249">
                      This is when you start seeing real results in the mirror.
                      The hump begins to flatten as your deep muscles reactivate
                      and tissue buildup reduces. Friends and family may comment
                      that you look "taller" or "more energetic."
                    </p>
                  </div>
                  <div className="bg-gradient-to-r from-purple-50 to-purple-100 p-5 rounded-lg" data-id="element-250">
                    <h4 className="font-bold text-lg mb-2" data-id="element-251">
                      WEEK 5-8: Structural Transformation
                    </h4>
                    <p data-id="element-252">
                      By this point, the changes are dramatic. Your posture
                      naturally corrects itself — even when you're not using the
                      device. The neuromuscular pathways have been retrained.
                      You stand taller, feel lighter, and look years younger.
                    </p>
                  </div>
                  <div className="bg-gradient-to-r from-yellow-50 to-yellow-100 p-5 rounded-lg" data-id="element-253">
                    <h4 className="font-bold text-lg mb-2" data-id="element-254">
                      WEEK 9+: Lasting Confidence
                    </h4>
                    <p data-id="element-255">
                      Continue using RejuvaNeck™ 3-4 times per week for
                      maintenance, and the results will last. Many users find
                      they no longer need daily sessions once their posture
                      memory is fully restored.
                    </p>
                  </div>
                </div>
              </div>
              {/* Expert Endorsements */}
              <div className="mb-10 bg-gray-50 p-6 rounded-lg" data-id="element-256">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-257">
                  But Don't Just Take My Word For It...
                </h2>
                <p className="mb-6" data-id="element-258">
                  RejuvaNeck™ has been featured in leading health publications
                  and recommended by healthcare professionals across the
                  country.
                </p>
                <div className="space-y-4" data-id="element-259">
                  <div className="bg-white p-5 rounded-lg border-l-4 border-blue-500" data-id="element-260">
                    <p className="font-semibold mb-1" data-id="element-261">
                      Dr. Michael Chen, DC (Chiropractor, Seattle, WA):
                    </p>
                    <p className="italic" data-id="element-262">
                      "I've been recommending RejuvaNeck to my patients for the
                      past year, and the results have been remarkable. It's the
                      first at-home device I've seen that actually addresses the
                      deep cervical stabilizers. For women dealing with postural
                      hyperkyphosis, this is a game-changer."
                    </p>
                  </div>
                  <div className="bg-white p-5 rounded-lg border-l-4 border-green-500" data-id="element-263">
                    <p className="font-semibold mb-1" data-id="element-264">
                      Dr. Amanda Foster, PT, DPT (Physical Therapist, Chicago,
                      IL):
                    </p>
                    <p className="italic" data-id="element-265">
                      "The combination of EMS and heat therapy is exactly what
                      we use in clinical settings for postural retraining.
                      RejuvaNeck brings that same technology home at a fraction
                      of the cost. I tell my patients this is the best
                      investment they can make in their long-term spinal
                      health."
                    </p>
                  </div>
                </div>
              </div>
              {/* Special Offer Section */}
              <div className="mb-10 bg-gradient-to-r from-red-50 to-orange-50 p-6 rounded-lg border-2 border-red-200" data-id="element-266">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-267">
                  Special Offer For {userCity} Residents
                </h2>
                <div className="mb-6 bg-white rounded-lg overflow-hidden" data-id="element-268">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/qBQ8RBzQ5M9qkoTvjAj6Mh/ChatGPT_Image_11_%CE%9D%CE%BF%CE%B5_2025%2C_09_06_41_%CE%BC.%CE%BC..png" alt="RejuvaNeck device with packaging and guarantee badge" className="w-full h-auto" data-id="element-269" />
                </div>
                <p className="mb-4" data-id="element-270">
                  Right now, RejuvaNeck™ is offering an exclusive 40% OFF
                  discount for readers in {userCity}.
                </p>
                <p className="mb-4" data-id="element-271">But I have to be honest with you...</p>
                <p className="mb-4" data-id="element-272">
                  Due to overwhelming demand and recent coverage in major health
                  publications, inventory has been flying off the shelves.
                </p>
                <p className="mb-4" data-id="element-273">
                  The company is doing everything they can to keep up with
                  orders, but stock is currently limited.
                </p>
                <h3 className="font-bold text-lg mb-3" data-id="element-274">
                  HERE'S WHAT YOU GET TODAY:
                </h3>
                <div className="space-y-2 mb-6" data-id="element-275">
                  <div className="flex items-start" data-id="element-276">
                    <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={20} data-id="element-277" />
                    <p data-id="element-278">
                      RejuvaNeck™ Device with EMS Micro-Pulse Technology & Heat
                      Therapy
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-279">
                    <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={20} data-id="element-280" />
                    <p data-id="element-281">USB Charging Cable (compatible with any USB port)</p>
                  </div>
                  <div className="flex items-start" data-id="element-282">
                    <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={20} data-id="element-283" />
                    <p data-id="element-284">User Guide with recommended protocols</p>
                  </div>
                  <div className="flex items-start" data-id="element-285">
                    <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={20} data-id="element-286" />
                    <p data-id="element-287">
                      30-Day Money-Back Guarantee (see visible results or get a
                      full refund)
                    </p>
                  </div>
                  <div className="flex items-start" data-id="element-288">
                    <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={20} data-id="element-289" />
                    <p data-id="element-290">FREE Worldwide Shipping</p>
                  </div>
                  <div className="flex items-start" data-id="element-291">
                    <CheckCircle className="text-green-500 mr-2 mt-1 flex-shrink-0" size={20} data-id="element-292" />
                    <p data-id="element-293">1-Year Warranty on all electronics</p>
                  </div>
                </div>
                <div className="bg-white p-6 rounded-lg mb-6" data-id="element-294">
                  <h3 className="font-bold text-xl mb-2" data-id="element-295">💰 PRICING:</h3>
                  <p className="text-gray-500 line-through text-lg" data-id="element-296">
                    Regular Price: $299
                  </p>
                  <p className="text-3xl font-bold text-green-600 mb-2" data-id="element-297">
                    TODAY ONLY: $179 (40% OFF!)
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-298">
                    This is less than the cost of 2 physical therapy sessions —
                    but provides results that last.
                  </p>
                  <p className="mt-3 text-sm font-semibold" data-id="element-299">
                    ✅ FSA/HSA ELIGIBLE
                  </p>
                  <p className="text-sm text-gray-600" data-id="element-300">
                    That means you can use pre-tax dollars from your health
                    savings account. Effectively saving you an additional 20-30%
                    depending on your tax bracket.
                  </p>
                </div>
                <div className="bg-red-100 border-2 border-red-400 p-4 rounded-lg mb-6" data-id="element-301">
                  <p className="font-bold text-lg mb-2" data-id="element-302">
                    🚨 URGENT: LIMITED STOCK AVAILABLE
                  </p>
                  <p data-id="element-303">
                    Due to high demand, RejuvaNeck™ can only guarantee
                    availability for the next 48 hours. After that, the next
                    shipment won't arrive until late December.
                  </p>
                </div>
                <p className="mb-6" data-id="element-304">
                  Don't let another month go by hiding your neck with scarves
                  and feeling self-conscious in photos.
                </p>
                <div className="text-center" data-id="element-305">
                  <a href="https://thegliserastore.com/pages/glisera-sales-page" className="bg-green-600 hover:bg-green-700 text-white font-bold py-4 px-8 rounded-lg shadow-md transition-all transform hover:scale-105 inline-block text-center uppercase tracking-wider text-lg" data-id="element-306">
                    CLAIM YOUR 40% OFF NOW →
                  </a>
                  <p className="text-sm text-gray-600 mt-3" data-id="element-307">
                    ✓ 30-Day Money-Back Guarantee | ✓ FREE Shipping | ✓ Limited
                    Time Offer
                  </p>
                </div>
              </div>
              {/* Guarantee Section */}
              <div className="mb-10 bg-green-50 p-6 rounded-lg border-2 border-green-300" data-id="element-308">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-309">
                  30-Day Money-Back Guarantee: Try It Risk-Free
                </h2>
                <p className="mb-4" data-id="element-310">Here's my promise to you:</p>
                <p className="mb-4" data-id="element-311">
                  Order RejuvaNeck™ today. Use it for 15 minutes a day for the
                  next 30 days.
                </p>
                <p className="mb-4" data-id="element-312">
                  If you don't see a visible reduction in your neck hump...
                </p>
                <p className="mb-4" data-id="element-313">
                  If you don't feel less pain and tension...
                </p>
                <p className="mb-4" data-id="element-314">
                  If you don't feel more confident and upright...
                </p>
                <p className="mb-4 font-semibold" data-id="element-315">
                  Simply return it for a full refund. No questions asked.
                </p>
                <p className="text-lg font-bold" data-id="element-316">
                  You have absolutely nothing to lose — and everything to gain.
                </p>
              </div>
              {/* Final CTA Section */}
              <div className="mb-10" data-id="element-317">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-318">
                  The Choice Is Yours
                </h2>
                <div className="mb-6 rounded-lg overflow-hidden" data-id="element-319">
                  <img src="https://uploadthingy.s3.us-west-1.amazonaws.com/hH4BhU4rx3qUhHuaV2ZmnE/ChatGPT_Image_11_%CE%9D%CE%BF%CE%B5_2025%2C_09_06_39_%CE%BC.%CE%BC..png" alt="Confident woman with improved posture" className="w-full h-auto" data-id="element-320" />
                </div>
                <p className="mb-4" data-id="element-321">
                  You can continue living with the neck hump, hoping it won't
                  get worse...
                </p>
                <p className="mb-4" data-id="element-322">
                  Continue spending money on temporary solutions that don't
                  address the root cause...
                </p>
                <p className="mb-4" data-id="element-323">
                  Continue avoiding photos and feeling self-conscious every time
                  you catch your reflection...
                </p>
                <p className="mb-4 font-semibold" data-id="element-324">Or...</p>
                <p className="mb-4" data-id="element-325">
                  You can take action today with a solution that's already
                  helped thousands of women just like you reverse their neck
                  hump, stand taller, and feel confident again.
                </p>
                <p className="mb-4" data-id="element-326">The decision is yours.</p>
                <p className="mb-4" data-id="element-327">But please don't wait.</p>
                <p className="mb-6" data-id="element-328">
                  At this discounted price and with limited inventory,
                  RejuvaNeck™ won't be available at this offer for long.
                </p>
              </div>
              {/* FAQ Section */}
              <div className="mb-10" data-id="element-329">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-6" data-id="element-330">
                  Frequently Asked Questions
                </h2>
                <div className="space-y-4" data-id="element-331">
                  <div className="bg-gray-50 p-5 rounded-lg" data-id="element-332">
                    <h4 className="font-semibold mb-2" data-id="element-333">
                      Q: How long does it take to see results?
                    </h4>
                    <p data-id="element-334">
                      A: Most women notice reduced pain and tension within the
                      first week. Visible reduction in the hump typically
                      appears within 2-4 weeks of consistent use (15 minutes
                      daily).
                    </p>
                  </div>
                  <div className="bg-gray-50 p-5 rounded-lg" data-id="element-335">
                    <h4 className="font-semibold mb-2" data-id="element-336">Q: Is it safe?</h4>
                    <p data-id="element-337">
                      A: Yes! RejuvaNeck™ uses the same EMS technology that
                      physical therapists have used safely for decades. It's
                      FDA-registered and has been tested for safety and
                      efficacy.
                    </p>
                  </div>
                  <div className="bg-gray-50 p-5 rounded-lg" data-id="element-338">
                    <h4 className="font-semibold mb-2" data-id="element-339">
                      Q: Will it work for severe cases?
                    </h4>
                    <p data-id="element-340">
                      A: RejuvaNeck™ is designed to address mild to moderate
                      postural hyperkyphosis (the most common type of neck
                      hump). If you have severe curvature or an underlying
                      medical condition, please consult your doctor before use.
                    </p>
                  </div>
                  <div className="bg-gray-50 p-5 rounded-lg" data-id="element-341">
                    <h4 className="font-semibold mb-2" data-id="element-342">
                      Q: How is this different from a massage gun?
                    </h4>
                    <p data-id="element-343">
                      A: Massage guns (like Theragun) use percussion therapy
                      that only addresses surface muscles. RejuvaNeck™ uses EMS
                      technology that stimulates the deep cervical stabilizer
                      muscles — the ones that actually control your posture.
                    </p>
                  </div>
                  <div className="bg-gray-50 p-5 rounded-lg" data-id="element-344">
                    <h4 className="font-semibold mb-2" data-id="element-345">
                      Q: Can I use it if I have a pacemaker or other medical
                      device?
                    </h4>
                    <p data-id="element-346">
                      A: No. EMS devices should not be used by anyone with
                      electronic implants, pacemakers, or during pregnancy.
                      Please consult your physician if you have any medical
                      concerns.
                    </p>
                  </div>
                  <div className="bg-gray-50 p-5 rounded-lg" data-id="element-347">
                    <h4 className="font-semibold mb-2" data-id="element-348">
                      Q: What if it doesn't work for me?
                    </h4>
                    <p data-id="element-349">
                      A: That's what the 30-day guarantee is for! If you don't
                      see results within 30 days, simply return it for a full
                      refund. No questions asked.
                    </p>
                  </div>
                  <div className="bg-gray-50 p-5 rounded-lg" data-id="element-350">
                    <h4 className="font-semibold mb-2" data-id="element-351">
                      Q: How long is the warranty?
                    </h4>
                    <p data-id="element-352">
                      A: RejuvaNeck™ comes with a 1-year manufacturer warranty
                      covering all electronic components.
                    </p>
                  </div>
                  <div className="bg-gray-50 p-5 rounded-lg" data-id="element-353">
                    <h4 className="font-semibold mb-2" data-id="element-354">
                      Q: Is the 40% discount available all the time?
                    </h4>
                    <p data-id="element-355">
                      A: No. This is a limited-time promotional offer for{' '}
                      {userCity} residents only. Once inventory runs out or the
                      promotion ends, the price will return to the regular $299.
                    </p>
                  </div>
                  <div className="bg-gray-50 p-5 rounded-lg" data-id="element-356">
                    <h4 className="font-semibold mb-2" data-id="element-357">
                      Q: How often should I use it?
                    </h4>
                    <p data-id="element-358">
                      A: For best results, use RejuvaNeck™ for 15 minutes daily
                      for the first 8 weeks. After that, 3-4 times per week for
                      maintenance.
                    </p>
                  </div>
                  <div className="bg-gray-50 p-5 rounded-lg" data-id="element-359">
                    <h4 className="font-semibold mb-2" data-id="element-360">
                      Q: Is it uncomfortable?
                    </h4>
                    <p data-id="element-361">
                      A: Not at all! Most users describe the sensation as a
                      gentle, soothing pulse combined with relaxing warmth. It's
                      designed to help you relax, not tense up like percussion
                      massagers.
                    </p>
                  </div>
                </div>
              </div>
              {/* Final Thought */}
              <div className="mb-10 bg-gradient-to-r from-purple-50 to-pink-50 p-6 rounded-lg" data-id="element-362">
                <h2 className="text-xl md:text-2xl font-bold text-gray-800 mb-4" data-id="element-363">
                  Final Thought: You Deserve To Feel Confident Again
                </h2>
                <p className="mb-4" data-id="element-364">
                  I know how frustrating it is to try solution after solution,
                  only to see the same hump staring back at you in the mirror.
                </p>
                <p className="mb-4" data-id="element-365">
                  I know the embarrassment of avoiding certain clothes, certain
                  angles, certain situations.
                </p>
                <p className="mb-4" data-id="element-366">
                  I know the fear that this is just "part of getting older" and
                  there's nothing you can do about it.
                </p>
                <p className="mb-4 font-semibold" data-id="element-367">
                  But I'm here to tell you: That's not true.
                </p>
                <p className="mb-4" data-id="element-368">
                  Your neck hump is not a life sentence. It's a structural
                  problem with a structural solution.
                </p>
                <p className="mb-4" data-id="element-369">And that solution is RejuvaNeck™.</p>
                <p className="mb-4" data-id="element-370">
                  Thousands of women just like you have already reclaimed their
                  confidence, their posture, and their comfort.
                </p>
                <p className="mb-6 text-lg font-bold" data-id="element-371">Now it's your turn.</p>
                <p className="mb-4" data-id="element-372">Don't wait another day.</p>
              </div>
            </div>
          </main>
          {/* Right-side CTA */}
          <aside className="hidden lg:block lg:w-80 lg:ml-8 lg:flex-shrink-0 mt-6" data-id="element-373">
            <div className="sticky top-6" data-id="element-374">
              <StickyCTA showNewImage={true} data-id="element-375" />
            </div>
          </aside>
        </div>
      </div>
      {/* Sticky CTA - Mobile Only */}
      <div className="lg:hidden fixed bottom-0 left-0 right-0 bg-white border-t border-gray-200 p-3 z-50 shadow-lg" data-id="element-376">
        <a href="https://thegliserastore.com/pages/glisera-sales-page" className="bg-green-600 hover:bg-green-700 text-white font-bold py-3 px-4 rounded-lg shadow-md transition-all w-full uppercase tracking-wider text-center block text-sm sm:text-base" data-id="element-377">
          GET 40% OFF REJUVANECK™ NOW!
        </a>
      </div>
      {/* Special Offer Banner */}
      <div className="w-full bg-red-50 border-y border-red-200" data-id="element-378">
        <div className="container mx-auto px-4 py-4 sm:py-6" data-id="element-379">
          <div className="flex flex-col sm:flex-row items-center justify-center text-center gap-3 sm:gap-4" data-id="element-380">
            <div className="flex items-center" data-id="element-381">
              <AlertCircle className="text-red-500 mr-2 flex-shrink-0" size={24} data-id="element-382" />
              <p className="font-bold text-base sm:text-lg" data-id="element-383">SPECIAL OFFER:</p>
            </div>
            <p className="font-bold text-red-700 text-sm sm:text-base md:text-lg px-2 sm:px-4" data-id="element-384">
              Get RejuvaNeck™ at 40% OFF + FREE Shipping for a Limited Time!
            </p>
            <a href="https://thegliserastore.com/pages/glisera-sales-page" className="bg-green-600 hover:bg-green-700 text-white font-bold py-2 sm:py-3 px-4 sm:px-6 rounded-lg text-sm sm:text-base whitespace-nowrap inline-block w-full sm:w-auto" data-id="element-385">
              CLAIM OFFER
            </a>
          </div>
        </div>
      </div>
      {/* Disclaimer */}
      <footer className="w-full bg-gray-100" data-id="element-386">
        <div className="container mx-auto px-4 py-6 max-w-4xl" data-id="element-387">
          <div className="text-xs text-gray-500 pt-6 mb-8" data-id="element-388">
            <p className="mb-2" data-id="element-389">
              This is an advertisement and not an actual news article, blog, or
              consumer protection update. The story depicted on this site and
              the persons depicted in the story are not actual news. Rather,
              this story is based on the results that some people who have used
              these products have achieved. The results portrayed in the story
              and in the testimonials are illustrative and may not be the
              results that you achieve with these products. This page could
              receive compensation for clicks on or purchase of products
              featured on this site. Individual results may vary.
            </p>
            <div className="flex flex-wrap space-x-2 mb-2" data-id="element-390">
              <span data-id="element-391">About Us</span>
              <span data-id="element-392">|</span>
              <span data-id="element-393">Terms of Use</span>
              <span data-id="element-394">|</span>
              <span data-id="element-395">Privacy Policy</span>
            </div>
            <p className="mb-2" data-id="element-396">
              Trademarks utilized on our website belong to their respective
              owners and no implied or expressed endorsement of our website or
              services is intended. Through in-depth research and experienced
              editors we provide feedback about products and services. We are
              independently owned, and opinions expressed here are our own. This
              website is an independent professional comparison and review site
              supported by referral fees from the sites and products featured.
            </p>
            <p data-id="element-397">©2025 Health & Wellness Insights. All Rights Reserved.</p>
          </div>
        </div>
      </footer>
    </div>;
};